import { reportSubstitutionSettlementsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SUBSTITUTION_SETTLEMENTS_FILTERS,
  RESTORE_INITIAL
} = reportSubstitutionSettlementsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSubstitutionSettlementsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SUBSTITUTION_SETTLEMENTS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
